import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import {en} from "./en";
import {ru} from "./ru";
import {LANGUAGE} from "../constants";

const resources = {
    en: {
        translation: en
    },
    ru: {
        translation: ru
    }
}

i18n
    .use(initReactI18next)
    .init({
        returnNull: false,
        resources,
        lng: LANGUAGE.toLowerCase(),
        fallbackLng: LANGUAGE.toLowerCase(),
        interpolation: {
            escapeValue: false
        },
        react: { useSuspense: false }
    });

export default i18n;
